// extracted by mini-css-extract-plugin
export var smallSpinner = "_wq-0";